import { AssignmentRule } from 'app/library/module-certificates/enums/assignment-rule.enum';
import { ModuleCertificateExtended } from './module-certificate.extended.model';

export class ModuleCertificateCommand {
    assignment_rule: AssignmentRule;
    section?: {
        id: number;
    };

    constructor(moduleCertificate: ModuleCertificateExtended) {
        this.assignment_rule = moduleCertificate.assignmentRule;
        if (moduleCertificate.section) {
            this.section = {
                id: parseInt(moduleCertificate.section.id),
            };
        }
    }
}
